import {
  GET_PROJECTS, GET_PROJECT, CREATE_PROJECT, EDIT_PROJECT, DELETE_PROJECT,
  ADD_MEMBER, REMOVE_MEMBER,
} from './project.types';

export const projectActions = {
  getProjects: (params) => ({
    type: GET_PROJECTS,
    payload: params,
  }),
  getProject: (id) => ({
    type: GET_PROJECT,
    payload: id,
  }),
  createProject: (data) => ({
    type: CREATE_PROJECT,
    payload: data,
  }),
  editProject: (id, data) => ({
    type: EDIT_PROJECT,
    payload: { id, data },
  }),
  deleteProject: (id) => ({
    type: DELETE_PROJECT,
    payload: id,
  }),
  addMember: (projectId, userId) => ({
    type: ADD_MEMBER,
    payload: { projectId, userId },
  }),
  removeMember: (projectId, userId) => ({
    type: REMOVE_MEMBER,
    payload: { projectId, userId },
  }),
};
